import React from 'react'
import { Input } from 'antd'
import './Input.styl'

const SbInput = (props) => <Input className="sb-input" {...props} />
export default SbInput
